import {useState} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {Link} from 'react-router-dom'
import AddIcon from '@mui/icons-material/Add'
import {Button} from 'primereact/button'
import {InputText} from 'primereact/inputtext'
import {Dialog} from 'primereact/dialog'
import {Dropdown} from 'primereact/dropdown'
import {Calendar} from 'primereact/calendar'
import {Divider} from 'primereact/divider'
import {CheckIcon} from 'primereact/icons/check'
import {StarIcon} from 'primereact/icons/star'
import clsx from 'clsx'
import 'primeicons/primeicons.css'
import 'primereact/resources/primereact.css'
import {InputTextarea} from 'primereact/inputtextarea'
import AddEditInquiryModal from './AddEditInquiryModal'
// import 'primereact/resources/themes/lara-light-indigo/theme.css'
export default function AdmissionHeader() {
  const [visible, setVisible] = useState(false)
  const [modalHeader, setModalHeader] = useState('')
  const [loading, setLoading] = useState(false)
  return (
    // <div>
    <>
      <div className={`card mb-6 flex-md-row justify-content-md-end align-items-end py-5`}>
        <Link to={`ViewApplicants`} className='me-6'>
          <Button
            label='View Applicants'
            rounded
            severity='info'
            //   icon={<AddIcon />}
            style={{
              borderRadius: '2rem',
            }}
          />
        </Link>

        <Button
          label='Add Inquiry'
          className='me-6'
          rounded
          severity='info'
          icon={<AddIcon />}
          style={{
            borderRadius: '2rem',
          }}
          onClick={() => {
            setModalHeader('Add Inquiry')
            setVisible(true)
          }}
        />
      </div>

      {visible && (
        <AddEditInquiryModal
          modalHeader={modalHeader}
          data={{}}
          visible={visible}
          setVisible={setVisible}
          // key={Date.now()}
        />
      )}
    </>
  )
}
